import * as React from "react";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import { ResizerStd } from "src/pages/EntityFiltersPage/AsyncTableView/ResizerStd";
import styles from "./Pl2GanttLeftHeadCell.module.less";
import { Planning2GanttStore } from "../Planning2GanttStore";
import {
  Planning2Column,
  planning2MinColumnWidth,
} from "../../Planning2Table/Planning2Column";

type PropsPl2GanttLeftHeadCell = {
  gantt: Planning2GanttStore;
  column: Planning2Column;
};

export const Pl2GanttLeftHeadCell: React.FC<PropsPl2GanttLeftHeadCell> =
  observer((props) => {
    const { gantt, column } = props;
    const { title } = column;
    const cref = React.useRef(null);
    const [showTooltip, setShowTooltip] = React.useState(false);

    // Служебная колонка для чекбоксов не поддерживает изменение ширины
    if (column.key[0] === "@") {
      return <div className={styles.selection}>{column.title}</div>;
    }
    return (
      <div ref={cref} className={styles.resizable}>
        <Tooltip
          title={typeof title === "string" ? title : undefined}
          open={showTooltip}
        >
          <div
            className={styles.title}
            onMouseEnter={(e) => {
              const elem = e.currentTarget;
              setShowTooltip(elem.scrollHeight > elem.clientHeight);
            }}
            onMouseLeave={() => setShowTooltip(false)}
          >
            {title}
          </div>
        </Tooltip>
        <ResizerStd
          column={column}
          containerRef={cref.current ?? undefined}
          store={gantt.tableStore.ctrlResizable}
          minWidth={planning2MinColumnWidth}
        />
      </div>
    );
  });
